module.exports = __webpack_public_path__ + "media/images/logos/magnet-463c146ac49628ce3d5f2634e2da71e3.png";